function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function loopData(data, condition, result) {
  var labelList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var valueList = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  data.forEach(function (item) {
    if (item.children && item.children.length > 0) {
      loopData(item.children, condition, result, [].concat(_toConsumableArray(labelList), [item.label]), [].concat(_toConsumableArray(valueList), [item.value]));
    } else {
      if (condition(item)) {
        result.push({
          labelList: [].concat(_toConsumableArray(labelList), [item.label]),
          valueList: [].concat(_toConsumableArray(valueList), [item.value]),
          label: item.label,
          value: item.value
        });
      }
    }
  });
}

export function getSearchResult(data, keywords) {
  var result = [];

  var condition = function condition(item) {
    return item.label.toLowerCase().indexOf(keywords) > -1 || item.fuzzy && item.fuzzy.toLowerCase().indexOf(keywords) > -1;
  };

  loopData(data, condition, result);
  return result;
}
export function getFrequentData(data, frequentValues) {
  var result = [];
  frequentValues.forEach(function (value) {
    var condition = function condition(item) {
      return item.value === value;
    };

    loopData(data, condition, result);
  });
  return result;
}
export function getSelectedByCodes(data, codes) {
  var selectedList = [];

  var loop = function loop(list, code) {
    var selected = null;
    list.forEach(function (item) {
      if (item.value === code) {
        selected = item;
      }
    });
    return selected;
  };

  codes.forEach(function (code, index) {
    var list = index === 0 ? data : selectedList[index - 1].children;
    selectedList.push(loop(list, code));
  });
  return selectedList;
}
//# sourceMappingURL=util.js.map
